import { Link } from 'gatsby';
import React, { FC } from 'react';
import { Navbar, Container, Nav, NavDropdown } from 'react-bootstrap';
import { CgExternal } from 'react-icons/cg';
import { FaYoutube } from 'react-icons/fa';
import promlabsLogo from '../images/promlabs_logo.svg';

const Header: FC = () => (
  <header>
    <Navbar expand="md" bg="light">
      <Container>
        <Navbar.Brand to="/" href="/" as={Link}>
          <img src={promlabsLogo} height="40" alt="PromLabs logo" className="d-inline-block align-top" />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="top-navbar-nav" />
        <Navbar.Collapse id="top-navbar-nav">
          <Nav className="ms-auto">
            <Nav.Link href="https://training.promlabs.com/" target="_blank">
              Self-Paced Courses
            </Nav.Link>
            <Nav.Link
              as={Link}
              to="/promql-training/"
              href="/promql-training/"
              activeStyle={{ color: 'black' }}
              partiallyActive
            >
              Live Trainings
            </Nav.Link>
            <NavDropdown title="Resources" id="basic-nav-dropdown">
              <NavDropdown.Item as={Link} to="/promql-cheat-sheet/" href="/promql-cheat-sheet/">
                PromQL Cheat Sheet
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/promql-compliance-tests/" href="/promql-compliance-tests/">
                PromQL Compliance Tests
              </NavDropdown.Item>
              <NavDropdown.Item href="https://www.youtube.com/@PromLabs" target="_blank">Prometheus Videos <FaYoutube /> <CgExternal color="#e65013" /></NavDropdown.Item>
              <NavDropdown.Item href="https://demo.promlabs.com/" target="_blank">
                Prometheus Demo Deployment <CgExternal color="#e65013" />
              </NavDropdown.Item>
              <NavDropdown.Item href="https://demo.promlens.com/" target="_blank">
                PromLens Demo <CgExternal color="#e65013" />
              </NavDropdown.Item>
              <NavDropdown.Item href="https://relabeler.promlabs.com/" target="_blank">
                Relabeler Playground <CgExternal color="#e65013" />
              </NavDropdown.Item>
            </NavDropdown>
            <Nav.Link as={Link} to="/blog/" href="/blog/" activeStyle={{ color: 'black' }} partiallyActive>
              Blog
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  </header>
);

export default Header;
